import { type FC } from 'react'
import { MeetingInsights } from './MeetingInsights/MeetingInsights'
import { MeetingInsightsSkeleton } from './MeetingInsights/MeetingInsightsSkeleton'
import { ADVISOR_INSIGHTS_TIME_RANGE, useAdvisorInsightsData } from '../../../../../common/useInsightsData'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'

interface MeetingPrepInsightsProps {
  meetingTemplateId: string
  meetingTypeName: string
}

export const MeetingPrepInsights: FC<MeetingPrepInsightsProps> = ({ meetingTemplateId, meetingTypeName }) => {
  const accountId = useAppSelector(selectAccountId)
  const {
    data: insightsData,
    isLoading: isInsightsDataLoading,
    isFetching: isInsightsDataFetching,
  } = useAdvisorInsightsData(accountId, ADVISOR_INSIGHTS_TIME_RANGE, { meetingTemplateId })

  if (isInsightsDataLoading || isInsightsDataFetching) {
    return <MeetingInsightsSkeleton />
  }

  if (!insightsData) {
    return null
  }

  return <MeetingInsights data={insightsData} meetingTypeName={meetingTypeName} />
}
